/**
 * Copyright 2026 Ziz Academy
 */

import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export const Navbar: React.FC = () => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    const getEmoji = () => {
        return user?.role === 'TEACHER' ? '👩‍🏫' : (user?.role === 'ADMIN' || user?.role === 'SUPER_ADMIN') ? '👨‍💼' : '🎒';
    };

    return (
        <nav className="navbar" data-testid="navbar">
            <Link to="/" className="navbar-brand">
                🎓 Exam Portal
            </Link>

            <div className="navbar-nav">
                {/* Public links always visible */}
                <Link to="/" className="nav-link">🏠 Home</Link>
                <Link to="/about" className="nav-link">ℹ️ About</Link>
                <Link to="/contact" className="nav-link">✉️ Contact</Link>

                {/* Authenticated role-specific links */}
                {user?.role === 'STUDENT' && (
                    <>
                        <Link to="/" className="nav-link">📚 Available Exams</Link>
                        <Link to="/my-submissions" className="nav-link">📝 My Results</Link>
                    </>
                )}

                {user?.role === 'TEACHER' && (
                    <>
                        <Link to="/" className="nav-link">📋 My Exams</Link>
                    </>
                )}

                {(user?.role === 'ADMIN' || user?.role === 'SUPER_ADMIN') && (
                    <>
                        <Link to="/" className="nav-link">📊 Dashboard</Link>
                    </>
                )}

                {/* Right side: auth controls */}
                {user ? (
                    <div className="user-info">
                        <div className="user-avatar">{getEmoji()}</div>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <span>{user?.name}</span>
                            {user?.institutionName && (
                                <span style={{ fontSize: '0.8rem', opacity: 0.8 }}>🏫 {user.institutionName}</span>
                            )}
                        </div>
                        <button className="btn btn-outline btn-sm" onClick={handleLogout}>
                            👋  Logout
                        </button>
                    </div>
                ) : (
                    <div style={{ display: 'flex', gap: '0.5rem', marginLeft: 'auto' }}>
                        <Link to="/login" className="btn btn-outline btn-sm">Login</Link>
                        <Link to="/register" className="btn btn-secondary btn-sm">Register</Link>
                    </div>
                )}
            </div>
        </nav>
    );
};

export default Navbar;